const translations = {
  brokers: {
    selectBroker: 'Select Broker',
    selectBrokerGroup: 'Select Broker Group',
    selectBrokerType: 'Select Broker Type',
    newBrokerFormTitle: 'Setup New Broker',
  },
  catastrophe: {
    earthquake: 'Earthquake',
    flood: 'Flood',
    wind: 'Wind',
  },
  excelTable: {
    paginationInfo: 'Showing {{from}} - {{to}} of {{total}}',
    maximumRowsReached: 'Maximum rows reached',
    errorBeforeAddRow:
      'Please fill in all required data before adding a new row',
    addRow: 'Add Row',
    deleteRow: 'Delete Row',
    deleteRowContent: 'Are you sure you want to delete this row?',
  },
  general: {
    save: 'Save',
    close: 'Close',
    paymentReserveChange: 'Payment / Reserve Change',
    search: 'Search',
    createNewRecord: 'Create New Record',
    paginationFooter: 'Showing {{from}} - {{to}} of {{total}}',
    underwriter: 'Underwriter',
    currency: 'Currency',
    status: 'Status',
    country: 'Country',
    city: 'City',
    postcode: 'Postcode',
    address: 'Address',
    select: 'Select',
    comments: 'Comments',
    enter: 'Enter {{field}}',
    selectField: 'Select {{field}}',
    details: 'Details',
    yes: 'Yes',
    no: 'No',
    continue: 'Continue',
    yesProceed: 'Yes, proceed',
    okay: 'Okay',
    download: 'Download',
    edit: 'Edit',
    state: 'State',
    contactInformation: 'Contact Information',
    phoneNumber: 'Phone Number',
    companyInformation: 'Company Information',
    website: 'Website',
    complianceInformation: 'Compliance Information',
    email: 'Email',
    phoneNumberLower: 'phone number',
    url: 'URL',
    next: 'Next',
    back: 'Back',
    proceed: 'Proceed',
    cancel: 'Cancel',
    grandTotal: 'Grand Total',
    quotaShare: 'Quota Share',
    days: '{{days}} days',
    actionNeeded: 'Action Needed',
    startDate: 'Start Date',
    endDate: 'End Date',
    export: 'Export',
    nonNegative: '{{field}} must be non-negative',
    notZero: '{{field}} must not be zero',
    file: 'File',
  },
  fireModifiers: {
    fireModifiers: 'Fire Modifiers',
    construction: 'Construction',
    yearBuilt: 'Year Built',
    fireProtection: 'Fire Protection',
    riskManagement: 'Risk Management',
    coverageDeductibles: 'Coverage',
    totalFireModifier: 'Total Fire Modifier',
  },
  firePricingAnalysis: {
    firePricingAnalysis: 'Fire Pricing Analysis',
    property: 'Property',
    selectOccupancy: 'Select Occupancy',
    updateFirePricingAnalysisFailed:
      'Update Fire Pricing Analysis failed. Please try again.',
    severity: 'Severity',
    occupancy: 'Occupancy',
    numberOfLocations: 'Number of Locations',
    multiplier: 'Multiplier',
    pdValue: 'PD Value',
    pdRate: 'PD Rate',
    biValue: 'BI Value',
    biRate: 'BI Rate',
    tiv: 'TIV',
    fireRiskPremium: 'Fire Risk Premium (100%)',
    country: 'Country',
    suburb: 'Suburb',
    layerExpectedLossCost: 'Layer Expected Loss Cost',
    fireExposure: 'Fire Exposure (100%)',
    export: 'Export',
    layer: 'Layer',
    expectedLossCost: 'Expected Loss Cost',
    validation: {
      multiplierInvalid: 'Multiplier must be non-negative value',
      biRateInvalid: 'BI Rate must be non-negative value',
      pdRateInvalid: 'PD Rate must be non-negative value',
    },
  },
  firePricingSummary: {
    firePricingSummary: 'Fire Pricing Summary',
    layer: 'Layer',
    limit: 'Limit (100%)',
    excess: 'Excess (100%)',
    fireExpectedLossCost: 'Fire Expected Loss Cost',
    fireRateOnLine: 'Fire Rate on Line',
    fireRateAdequacy: 'Fire Rate Adequacy',
  },
  reinsured: {
    reinsured: 'Reinsured',
    setupNewReinsured: 'Setup New Reinsured',
    updateReinsured: 'Update Reinsured',
    setupCompanyParty: 'Setup Company Party',
    reinsuredGroup: 'Reinsured Group',
    legalEntityName: 'Reinsured Legal Entity Name',
    enterLegalEntityName: 'Enter Legal Entity Name',
    reinsuredName: 'Reinsured Name',
    enterReinsuredName: 'Enter Reinsured Name',
    reinsuredRecords: 'Reinsured Records',
  },
  submission: {
    submission: 'Submission',
    submissionLowercase: 'submission',
    newSubmissionTitle: 'Setup New Business Submission',
    submissionInformation: 'Submission Information',
    transactionDetailsAndClassification:
      'Transaction Details and Classification',
    submissionRegistration: 'Submission Registration',
    assignedHandler: 'Assigned Handler',
    namedUnderwriter: 'Named Underwriter',
    selectUnderwriter: 'Select Underwriter',
    underwritingYear: 'Underwriting Year',
    selectUnderwritingYear: 'Select Underwriting Year',
    inceptionDate: 'Inception Date',
    expiryDate: 'Expiry Date',
    enterInsured: 'Enter Insured',
    addNewInsured: 'Add New Insured',
    principalOccupation: 'Principal Occupation',
    selectPrincipalOccupation: 'Select Principal Occupation',
    selectCurrency: 'Select Currency',
    mainRegionAndRiskTerritory: 'Main Region & Risk Territory',
    selectMainRegionAndRiskTerritory: 'Select Main Region & Risk Territory',
    keyRiskLocation: 'Primary Risk Location',
    enterKeyRiskLocation: 'Enter Primary Risk Location',
    uploadFile: 'Upload File',
    cancelSubmission: 'Cancel Submission',
    createNewRecord: 'Create New Record',
    transactionType: 'Transaction Type',
    selectTransactionType: 'Select Transaction Type',
    placementType: 'Placement Type',
    selectPlacementType: 'Select Placement Type',
    lineOfBusiness: 'Line of Business',
    selectLineOfBusiness: 'Select Line of Business',
    subClass: 'Sub-Class',
    selectSubClass: 'Select Sub-Class',
    status: 'Status',
    selectStatus: 'Select Status',
    policyType: 'Policy Type',
    selectPolicyType: 'Select Policy Type',
    submissionStatus: 'Submission Status',
    selectSubmissionStatus: 'Select Submission Status',
    fileUpload: 'File Upload',
    validationCheck: 'Validation Check',
    systemVerification:
      'Our system is automatically verifying your information',
    duplicateCheck: 'Duplicate Check',
    submissionUnderReview: 'Submission Under Review',
    issueWithSubmissionCheckConfirmation:
      'There are minor issues that need to be addressed. Do you want to proceed with Setting a  Layer Structure and Peril Sub-limits.',
    issueWithSubmissionCheckAlert: `There are minor issues that need to be addressed. The underwriter will
        review your submission and decide whether to proceed to Set Layer
        Structure and Peril Sub-limits.`,
    recordCreatedSuccessfully: 'Submission record created successfully!',
    recordCreatedFailed: 'Create submission failed. Please try again.',
    navigation: {
      submissionRegistration: 'Submission Registration',
      submissionDetails: 'Submission Details',
      scheduleOfValues: 'Schedule of Values',
      fireRating: 'Fire Rating',
      catRating: 'Cat Rating',
      layerResults: 'Layer Results',
      binderDeployment: 'Binder Deployment',
      peerReview: 'Peer Review',
      quoteGeneration: 'Quote Generation',
      binding: 'Binding',
    },
    recordUpdatedSuccessfully: 'Submission record updated successfully!',
    recordUpdatedFailed: 'Update submission failed. Please try again.',
    submissionId: 'Submission ID',
    documents: 'Documents',
    assignedUnderwriter: 'Assigned Underwriter',
    underwriter: 'Underwriter',
    uwYear: 'UW Year',
    primaryRiskLocation: 'Main Region & Risk Territory',
    totalInsurableValue: 'Total Insurable Value',
    shareOfPremiumSigned: 'Share of Premium Signed',
    createNewSubmission: 'Create New Submission',
  },
  updateSubmissionStatusModal: {
    title: 'Update Submission Status',
    submissionStatus: 'Submission Status',
    confirm: 'Confirm',
    statusRequired: 'Please select a submission status',
  },
  closeSubmission: {
    title: 'Provide Reason For Closing Case',
    submissionStatus: 'Submission Status',
    competitorRateOnLine: 'Competitor Rate On Line',
    competitorRateOnExposure: 'Competitor Rate On Exposure',
    enterReason: 'Please state your reason',
    submitAndClose: 'Submit and Close',
    statusRequired: 'Please select a submission status',
    rateRangeError: 'Rate must be between 0 and 100',
    success: 'Submission closed successfully',
  },
  masterClaims: {
    createNewClaim: 'Create New Claim',
    reportedDate: 'Reported Date',
    lossDate: 'Loss Date',
    incurred: 'Incurred (Our Share)',
    payments: 'Payments (Our Share)',
    outstanding: 'Outstanding (Our Share)',
    claimsStatus: 'Claims Status',
    claimsHandler: 'Claims Handler',
    selectClaimsStatus: 'Select Claims Status',
    selectClaimsHandler: 'Select Claims Handler',
    reportedDateFrom: 'Reported Date From',
    reportedDateTo: 'Reported Date To',
    selectedClaimsHandler: 'Selected Claims Handler',
    claimsId: 'ClaimsId',
    broker: 'Broker',
    reinsured: 'Reinsured',
    binder: 'Binder',
  },
  binderClaims: {
    claimsId: 'Claims ID',
    selectBroker: 'Select Broker',
    selectReinsured: 'Select Reinsured',
    selectBinder: 'Select Binder',
  },
  layerStructure: {
    createdSuccessfully: 'Layer Structure records synced successfully!',
    createdFailed: 'Sync layer structure failed. Please try again.',
    errorBeforeAddRow:
      'Please fill in all required data before adding a new row',
    currencyMismatchWarning:
      'Please switch back to original currency ({{currency}}) to edit layer structures!',
    headers: {
      layerNumber: 'Layer Number',
      currency: 'Currency',
      limitType: 'Limit Type',
      limit: 'Limit (100%)',
      excess: 'Excess (100%)',
      deductibles: 'Deductibles (100%)',
      layerPremium: 'Layer Premium (100%)',
      totalDeductions: 'Total Deductions (%)',
      lineSize: 'Line Size (%)',
      shareOfLimitQuoted: 'Share of Limit Quoted',
      rateAdequacy: 'Rate Adequacy',
    },
    validation: {
      layerNumberRequired: 'Layer number must be a positive value',
      currencyRequired: 'Currency is required',
      limitTypeRequired: 'Limit Type is required',
      excessRequired: 'Excess is required for Excess of Loss type',
      totalDeductionsRange: 'Total Deductions must be between 0% and 20%',
      lineSizeRange: 'Line Size must be between 0% and 100%',
      emptyRow: 'Set Layer Structure or Delete',
      uniqueLayer:
        'Layer configuration must be unique (Limit Type, Limit, Excess, Deductibles)',
      maxLayers: 'Maximum of 10 layers allowed',
      minLayers: 'At least one layer is required',
    },
    paginationInfo: 'Showing {{from}} - {{to}} of {{total}}',
    deleteLayerTitle: 'Delete Layer',
    deleteLayerContent: 'Are you sure you want to delete this layer?',
  },
  insured: {
    insured: 'Insured',
    insuredName: 'Insured Name',
    insuredLongName: 'Insured Long Name',
    sanctionsStatus: 'Sanctions Status',
    sanctionsCompletionDate: 'Sanctions completion date',
    setupNewInsured: 'Setup New Insured',
    insuredDetails: 'Insured Details',
    enterInsuredName: 'Enter Insured Name',
    enterInsuredLongName: 'Enter Insured Long Name',
    sanctionsCompleted: 'Sanctions Completed',
    sanctionLastCompletionDate: 'Sanction Last Completion Date',
    completeInsured: 'Complete Insured',
    selectInsured: 'Select Insured',
    updateInsured: 'Update Insured',
    country: 'Country',
    sanctionsLastDate: 'Sanctions Last Date',
    insuredRecords: 'Insured Records',
  },
  broker: {
    broker: 'Broker',
    recordCreatedSuccessfully: 'Broker record created successfully!',
    recordUpdatedSuccessfully: 'Broker record updated successfully!',
    recordCreatedFailed: 'Create broker failed. Please try again.',
    recordUpdatedFailed: 'Update broker failed. Please try again.',
    setupNewBroker: 'Setup New Broker',
    updateBroker: 'Update Broker',
    brokerDetail: 'Broker Details',
    brokerName: 'Broker Name',
    brokerLegalEntityName: 'Broker Legal Entity Name',
    brokerGroup: 'Broker Group',
    brokerType: 'Broker Type',
    brokerEmailAddress: 'Broker Email Address',
    brokerEmail: 'Broker Email',
    claimsEmailAddress: 'Claims Email Address',
    claimsEmail: 'Claims Email',
    financeEmailAddress: 'Finance Email Address',
    financeEmail: 'Finance Email',
    hasTobaDone: 'Has a TOBA been done',
    tobaLastCompletionDate: 'TOBA Last Completion Date',
    hasKycDone: 'Has a KYC been done',
    kycLastCompletionDate: 'KYC Last Completion Date',
    createBrokerRecord: 'Create Broker Record',
    tobaStatus: 'TOBA status',
    kycStatus: 'KYC status',
    fetchBrokerFailed: 'Fetch broker failed. Please try again.',
  },
  catEvent: {
    catEventRecords: 'Cat Event Records',
    catEvent: 'Cat Event',
    eventName: 'Event Name',
    fromDate: 'From Date',
    toDate: 'To Date',
    selectCatCode: 'Select Cat Code',
    setupNewCatEvent: 'Setup New Cat Event',
    updateCatEvent: 'Update Cat Event',
    catEventDetails: 'Cat Event Details',
    createCatEvent: 'Create Cat Event',
    searchCatEventIfExists: 'Search Cat Event if exists',
  },
  perilSettings: {
    headers: {
      fire: 'Fire',
      wind: 'Wind',
      earthquake: 'Earthquake',
      flood: 'Flood',
    },
    includePeril: 'Include Peril',
    recordUpdatedFailed: 'Update Peril Settings failed. Please try again.',
  },
  forms: {
    discardChangesTitle: 'Discard Changes?',
    discardChangesOkText: 'Discard changes',
    discardChangesCancelText: 'Continue editing',
    discardChangesContent: `You're in the middle of creating a {{type}} record. Do you want to discard your changes?`,
    createRecordSuccess: '{{type}} record created successfully',
    createRecordFail: 'Create {{type}} failed. Please try again.',
    selectCountryFirst: 'Please select a country first',
    postalZipCode: 'Postal / Zip code',
    postal: 'Postal',
    updateRecordSuccess: '{{type}} record updated successfully',
    updateRecordFail: 'Update {{type}} failed. Please try again.',
    cancelConfirmationTitle: 'Cancel Confirmation',
    cancelConfirmationContent:
      'Are you sure you want to cancel? All unsaved changes will be lost.',
  },
  validation: {
    required: '{{field}} is required',
    requiredAndNumeric: '{{field}} is required and must be a number',
    dateInFuture: '{{field}} must be in the future',
    invalidOption: '{{field}} must be one of the valid options',
    dateAfterInception: '{{field}} must be after {{date}}',
    invalid: 'Invalid {{field}}',
    binderShareSignedExceedsWritten:
      'Binder Share Signed % should not exceed Binder Share Written %',
    fields: {
      underwriter: 'Underwriter',
      underwritingYear: 'Underwriting Year',
      inceptionDate: 'Inception Date',
      expiryDate: 'Expiry Date',
      insured: 'Insured',
      principalOccupation: 'Principal Occupation',
      currency: 'Currency',
      mainRegionAndRiskTerritory: 'Main Region and Risk Territory',
      transactionType: 'Transaction Type',
      lineOfBusiness: 'Line of Business',
      subClass: 'Sub-Class',
      status: 'Status',
      policyType: 'Policy Type',
    },
    numeric: '{{field}} must be numeric',
    numericPositive: '{{field}} must be a positive number',
    wholePositiveField: '{{field}} must be a whole number > 0',
    maxLength: '{{field}} can have a max length of {{length}} characters',
    validOption: 'Value must be one of the valid options',
    totalPercent: 'Total percent must be 100%',
    min: '{{field}} must be greater than {{min}}',
    max: '{{field}} must be less than {{max}}',
  },
  file: {
    uploadSuccess: '{{fileName}} uploaded successfully',
    uploadFailed: '{{fileName}} upload failed',
    invalidFormat: 'You can only upload {{fileTypes}} files!',
    invalidSize: 'File must be smaller than {{maximumSize}}MB!',
    fileExists: 'File {{fileName}} already exists!',
    fileRemoved: '{{fileName}} removed.',
    fileRemovedFailed: '{{fileName}} removal failed.',
    dragAndDrop: 'Drag and Drop file here or',
    maximumFileSize: 'Maximum file size: {{size}}MB',
    supportedFormat: 'Supported format: {{formats}}',
    totalFilesSize: 'Total: {{totalFiles}} files ({{totalSize}})',
    chooseFile: 'Choose File',
    maximumFileNumber: 'You can only upload {{maximumNumber}} files!',
    downloadFailed: '{{fileName}} download failed',
    confirmUpload: 'File upload confirmation',
    confirmUploadContent:
      'Do you want to proceed with uploading a new file? This will replace the existing file/data.',
    unsuccessfulCheckSourceFile: 'Unsuccessful - check source file',
  },
  login: {
    error: 'An error occurred while logging in, please try again!',
    welcomeText: 'Welcome to Pinnacle',
    actionText: 'Sign in with your organization account',
    signInWithMicrosoft: 'Sign in with Microsoft',
    allRightsReserved: '© {{year}} Pinnacle, All rights reserved',
    slogan: 'A Solutions Focused and Innovative Underwriting Approach',
  },
  submissionDetails: {
    tabs: {
      layerStructures: 'Layer Structures',
      subLimits: 'Sub-limits',
      basisOfCover: 'Basis Of Cover',
    },
  },
  subLimits: {
    headers: {
      currency: 'Currency',
      country: 'Country',
      peril: 'Peril (Wind, Flood, Earthquake)',
      subLimitAmount: 'Sub-limit amount',
    },
    perils: {
      wind: 'Wind',
      flood: 'Flood',
      earthquake: 'Earthquake',
    },
    validation: {
      layerNumberRequired: 'Layer number must be a positive value',
      duplicatePerilCountry: 'Peril and Country must be unique',
      currencyRequired: 'Currency is required',
      countryRequired: 'Country is required',
      perilRequired: 'Peril is required',
      subLimitAmountRequired: 'Sub-limit amount must be a positive value',
    },
    createdRecordsFailed: 'Create Sub-limits failed. Please try again.',
    errorBeforeAddRow:
      'Please fill in all required data before adding a new row',
    fixErrorsBeforeAddingRow: 'Please fix the errors before adding a new row',
    deleteRecordFailed: 'Delete Sub-limits failed. Please try again.',
    paginationInfo: 'Showing {{from}} - {{to}} of {{total}}',
    deleteSubLimitTitle: 'Delete Sub-limit',
    deleteSubLimitContent: 'Are you sure you want to delete this sub-limit?',
  },
  basisOfCover: {
    headers: {
      category: 'Category',
      basisOfCover: 'Basis of Cover',
    },
    options: {
      anyOneLocation: 'Any One Location',
      anyOneEvent: 'Any One Event',
      inTheAggregate: 'In the Aggregate',
    },
    validation: {
      basisOfCoverRequired: 'Basis of Cover is required',
    },
    recordUpdatedFailed: 'Update Basis of Cover failed. Please try again.',
  },
  scheduleOfValues: {
    crestaZone: 'Cresta Zone',
    occupancy: 'Occupancy',
    pdValue: 'PD Value',
    buildingValue: 'Building Value',
    cpe: 'CPE',
    stock: 'Stock',
    validLatitude: 'Latitude must be between -90 and 90',
    validLongitude: 'Longitude must be between -180 and 180',
    validYearBuilt: 'Year Built must be between 0 and {{maxYear}}',
    postalZipCode: 'Postal / ZIP Code',
    property: 'Property',
    streetAddress: 'Street Address',
    suburb: 'Suburb',
    pdDeductibles: 'PD Deductibles',
    biValue: 'BI Value',
    multiplier: 'Multiplier',
    totalInsurableValue: 'Total Insurable Value',
    latitude: 'Latitude',
    longitude: 'Longitude',
    constructionClass: 'Construction Class',
    roofType: 'Roof Type',
    numberOfStories: 'Number of Stories',
    yearBuilt: 'Year Built',
    fluvialFlood: 'Fluvial Flood',
    originalStormSurge: 'Original Storm Surge',
    originalPfRiskLevel: 'Original PF Risk Level',
    windstorm: 'Windstorm',
    hailstorm: 'Hailstorm',
    wildfire: 'Wildfire',
    totalInsurableValueCurrency: 'Total Insurable Value ({{currency}})',
    incidentalTiv: 'Incidental TIV ({{countries}})',
    locationAccuracyPercentage: 'Location Accuracy %',
    fetchCoordinates: 'Fetch Coordinates',
    fetchFromCatNat: 'Fetch Data from CatNat',
    deleteSovTitle: 'Delete Schedule of Value',
    deleteSovContent: 'Are you sure you want to delete this schedule of value?',
    deleteRecordFailed: 'Delete Schedule of Value failed. Please try again.',
    createdRecordsFailed: 'Create Schedule of Values failed. Please try again.',
  },
  catPricingSummary: {
    catPricingSummary: 'Cat Pricing Summary',
    headers: {
      layer: 'Layer',
      limit: 'Limit (100%)',
      excess: 'Excess (100%)',
      eqExpectedLossCost: 'EQ Expected Loss Cost',
      flExpectedLossCost: 'FL Expected Loss Cost',
      tcExpectedLossCost: 'TC Expected Loss Cost',
      totalExpectedLossCost: 'Total Expected Loss Cost',
      catRateAdequacy: 'Cat Rate Adequacy',
    },
    validation: {
      layerRequired: 'Layer is required',
    },
    createdRecordsFailed:
      'Create Cat Pricing Summary failed. Please try again.',
    deleteRecordFailed: 'Delete Cat Pricing Summary failed. Please try again.',
  },
  catPricingAnalysis: {
    headers: {
      property: 'Property',
      crestaZone: 'Cresta Zone',
      numberOfLocations: 'Number of Locations',
      catMultiplier: 'Cat Multiplier',
      tiv: 'TIV',
      catRate: 'Cat Rate',
      catRiskPremium: 'CAT Risk Premium (100%)',
      layerExpectedLossCost: '{{layer}} Cat Expected Loss Cost',
    },
    validation: {
      propertyRequired: 'Property is required',
      crestaZoneRequired: 'Cresta Zone is required',
      catMultiplierInvalid: 'Cat Multiplier must be a positive value',
      tivRequired: 'TIV is required',
      catRateInvalid: 'Cat Rate must be a positive value',
    },
    export: 'Export',
  },
  layerResults: {
    tableHeaders: {
      layerName: 'Layer',
      rateAdequacy: 'Rate Adequacy',
      exposureFull: '100% of Limit',
      pinnacleExposure: "Pinnacle's Exposure",
      premium: 'Premium',
      lossCost: 'Loss Cost',
      rateOnLine: 'Rate On Line (ROL)',
      rateOnExposure: 'Rate On Exposure (ROE)',
      expectedULR: 'Expected ULR',
      targetedMLR: 'Targeted MLR',
      ULRAdequacy: 'ULR Adequacy',
      returnOnCapital: 'Return On Capital',
      shareOfPremiumNet: 'Share of Premium Net',
      expectedProfit: 'Expected Profit',
      lineSize: 'Line Size',
      shareOfExpectedLossCost: 'Share of Expected Loss Cost',
      premiumNet: 'Premium Net',
      capitalAllocation: 'Capital Allocation',
    },
  },
  binderDeployment: {
    totalDeploymentPerBinderTable: 'Total Deployment Per Binder',
    primary: 'Primary',
    excessOfLoss: 'Excess of Loss',
    excessOfLossAndQuotaShare: 'Excess of Loss / Quota Share',
    duplicateContract: 'Duplicate Contract',
    shareOfLimitQuoted: 'Share of Limit Quoted',
    shareOfPremiumQuoted: 'Share of Premium Quoted',
    binder: 'Binder',
    layerNumber: 'Layer Number',
    layer: 'Layer',
    limitType: 'Limit Type',
    binderShareExceeds100: 'Total binder share cannot exceed 100%',
    binderShareExceedsLimit:
      'Share of limit quoted exceeds {{limitType}} max limit',
    getBinderError: 'Failed to retrieve binder details. Please try again.',
    layerNotFound: 'Layer not found',
    minimumSubRowsRequired:
      'Cannot delete row. Minimum of {{count}} sub-rows required per layer.',
    deleteContractError: 'Failed to delete contract. Please try again.',
    upsertContractError: 'Failed to save contract. Please try again.',
    reinsuredRequired: 'Reinsured is required',
    brokerRequired: 'Broker is required',
    binderRequired: 'Binder is required',
    binderShareRequired: 'Binder share is required',
  },
  binder: {
    binderRecords: 'Binder Records',
    selectBinder: 'Select Binder',
    status: 'Status',
    searchBinder: 'Search Binder if exists',
    setupNewBinder: 'Setup New Binder',
    updateBinder: 'Update Binder',
    binderName: 'Binder Name',
    binderLongName: 'Binder Long Name',
    authorityStartDate: 'Authority Start Date',
    authorityEndDate: 'Authority End Date',
    currency: 'Currency',
    primaryMaxLimit: 'Primary Max Limit',
    qsEolMaxLimit: 'Quota Share/Excess of Loss Max Limit',
    territories: 'Territories',
    markets: 'Markets',
    lineOfBusinesses: 'Line of Businesses',
    placeBroker: 'Placement Broker',
    placementBrokerCommission: 'Placement Broker Commission',
    pinCommission: 'PIN Commission',
    financialCreditRating: 'Financial Credit Rating',
    territory: 'Territory',
    lineOfBusinessProduct: 'Line of Business (Products)',
    excludedPrincipalOccupation: 'Excluded Principal Occupation',
    binderGroup: 'Binder Group',
    maxLimit: 'Max Limit',
    claimsReferralAmount: 'Claims Referral Amount',
    defaultFloatBankAccount: 'Default Float Bank Account',
    fileIds: 'Files',
    comment: 'Comment',
    createBinder: 'Create Binder',
    binder: 'Binder',
    binderCreatedSuccessfully: 'Binder created successfully!',
    binderCreatedFailed: 'Create binder failed. Please try again.',
    binderUpdatedSuccessfully: 'Binder updated successfully!',
    binderUpdatedFailed: 'Update binder failed. Please try again.',
    form: {
      binderDetail: 'Binder Details',
      brokerAndClaims: 'Broker and Claims',
      attachments: 'Attachments',
    },
    table: {
      binderGroup: 'Binder Group',
      binderName: 'Binder Name',
      startDate: 'Start Date',
      endDate: 'End Date',
      territories: 'Territories',
      status: 'Status',
      underwritingYear: 'Underwriting Year',
    },
  },
  binding: {
    totalDeploymentPerBinderTable: 'Total Deployment Per Binder',
    primary: 'Primary',
    binderShareWritten: 'Binder Share Written %',
    binderShareExceeds100: 'Total binder share cannot exceed 100%',
    excessOfLoss: 'Excess of Loss',
    shareOfLimitQuoted: 'Share of Limit Quoted',
    updateContractError: 'Failed to update contract. Please try again.',
    contractStatusUpdated: 'Contract status updated successfully.',
    shareOfPremiumQuoted: 'Share of Premium Quoted',
    shareOfLimitSigned: 'Share of Limit Signed',
    shareOfPremiumSigned: 'Share of Premium Signed',
    contractStatus: 'Contract Status',
    binderShareSigned: 'Binder Share Signed',
    action: 'Action',
    binder: 'Binder',
    layerNumber: 'Layer Number',
    layer: 'Layer',
    limitType: 'Limit Type',
    uploadSlip: 'Upload Slip',
    bindOrClose: 'Bind or Close',
    moveToPending: 'Move to Pending',
    moveToQuoted: 'Move to Quoted',
    status: 'Status',
    binderShareSignedInvalid:
      'Binder share signed cannot exceeds 100% or less than 0%',
  },
  peerReview: {
    tabs: {
      reviewNotes: 'Review Notes',
    },
    saveNotesSuccess: 'Notes saved successfully',
    saveReviewSuccess: 'Review saved successfully',
    underwritingNotes: 'Underwriting Notes',
    reviewStatus: 'Review Status',
    approvedDate: 'Approved Date',
    peerReviewNotes: 'Peer Review Notes',
    peerReview: 'Peer Review',
    saveReviewNoteFailed: 'Failed to save review note. Please try again.',
    reviewStatusOptions: {
      approved: 'Approved',
      approvedWithUpdates: 'Approved with Updates',
      notApproved: 'Not Approved',
      referToBinder: 'Refer to Binder',
    },
    addYourNotes: 'Add your notes here...',
    markAsPeerReviewed: 'Mark as Peer Reviewed',
  },
  contractDetail: {
    transactionDetailsAndClassification:
      'Transaction Details and Classification',
    documentNumber: 'Document Number',
    bindingDate: 'Binding Date',
    contractStatus: 'Contract Status',
    bookedExchangeRate: 'Booked Exchange Rate',
    policyType: 'Policy Type',
    transactionType: 'Transaction Type',
    lineOfBusiness: 'Line of Business',
    subClass: 'Sub-Class',
    amountOurShare: 'Amount (Our Share)',
    binder: 'Binder',
    namedUnderwriter: 'Named Underwriter',
    insured: 'Insured',
    reinsured: 'Reinsured',
    broker: 'Broker',
    brokerReference: 'Broker Reference',
    underwritingYear: 'Underwriting Year',
    inceptionDate: 'Inception Date',
    expiryDate: 'Expiry Date',
    premiumPaymentWarranty: 'Premium Payment Warranty',
    paymentWarrantyDate: 'Payment Warranty Date',
    declaration: 'Declarations',
    installments: 'Installments',
    principalOccupation: 'Principal Occupation',
    mainRiskTerritory: 'Main Risk Territory',
    binderPlacement: 'Binder Placement',
    totalInsurableValue: 'Total Insurable Value',
    layerType: 'Layer Type',
    basisOfCover: 'Basis of Cover',
    limit: 'Limit (100%)',
    excess: 'Excess (100%)',
    deductible: 'Deductible (100%)',
    layerPremium: 'Layer Premium (100%)',
    binderShareWritten: 'Binder Share Written %',
    binderShareSigned: 'Binder Share Signed %',
    shareOfLimitSigned: 'Share of Limit Signed',
    shareOfPremiumSigned: 'Share of Premium Signed',
    basePremium: 'Base Premium',
    fullAmount: '100% Amount',
    rateAdequacy: 'Rate Adequacy',
    rateMovement: 'Rate Movement',
    installmentDetails: 'Installment Details',
    installmentPercent: 'Installment Percent',
    installmentDueDate: 'Installment Due Date',
    incidental: 'Incidental',
    primaryRiskLocation: 'Primary Risk Location',
    incidentalCountry: 'Incidental Country',
    addIncidentalCountry: 'Add Incidental Country',
    underwritingComments: 'Underwriting Comments',
    addYourReasonHere: 'Add your reason here...',
    binderSchedule: 'Binder Schedule',
    provideReasonForClosingCase: 'Provide Reason for Closing Case',
    competitorRateOnLine: 'Competitor Rate on Line',
    competitorRateOnExposure: 'Competitor Rate on Exposure',
    pleaseStateYourReason: 'Please state your reason',
    back: 'Back',
    close: 'Close',
    bind: 'Bind',
    binderCashRemittance: 'Binder Cash Remittance',
    validation: {
      percentRange: 'Percentage must be between 0 and 100',
      totalPercent: 'Total percentage must equal 100% (current: {{total}}%)',
    },
    rate: 'Rate',
    amount: 'Amount',
    gstOnPremium: 'GST on Premium',
    cedingCommission: 'Ceding Commission',
    gstOnCedingCommission: 'GST on Ceding Commission',
    sourceBrokerage: 'Source Brokerage',
    gstOnSourceBrokerage: 'GST on Source Brokerage',
    ere: 'ERE',
    withholdingTax: 'Withholding Tax',
    otherDeductions: 'Other Deductions',
    gstOnEre: 'GST on ERE',
    netPremiumDueFromBroker: 'Net Premium Due from Broker',
    netPremiumReceivedFromBroker: 'Net Premium Received from Broker',
    pinnacleCommission: 'Pinnacle Commission',
    ait: 'AIT',
    taxesAndFees: 'Taxes and Fees',
    bindSuccess: 'Contract bind successfully!',
    closeSuccess: 'Contract closed successfully!',
    updateContractFailed: 'Failed to update contract. Please try again.',
    pleaseUploadSlip: 'Slip must be uploaded',
    saveSuccess: 'Save successfully!',
    addNewAdjustment: 'Add New Adjustment',
    mustUploadSlip: 'You must upload slip to proceed the next step',
    pinnacleReferenceNumber: 'Pinnacle Reference Number',
    ntuReason: 'Not Taken Up Reason',
    declarationDetails: 'Declaration Details',
    declarationDetail: {
      declarationName: 'Declaration Name',
      entityName: 'Entity Name',
      country: 'Country',
      programOrder: 'Program Order',
      programOrderTotalPremium: 'Program Order Total Premium',
      declarationTotalPremiumMismatch:
        'Total of {{field}} must equal {{layerPremium}}.',
      declarationDueDate: 'Declaration Due Date',
    },
    oldPinReferenceNumber: 'Old PIN Reference Number',
    originalRate: 'Original Rate',
    adjustedRate: 'Adjusted Rate',
    notesAndEndorsements: 'Notes and Endorsements',
    addYourNoteHere: 'Add your notes here...',
    stockDeclaration: 'Stock Declaration',
  },
  receipts: {
    receipts: 'Receipts',
    cashReceipts: 'Cash Receipts',
    newReceipt: 'Create New Receipt',
    createNewReceipt: 'Create New Receipt',
  },
  cashReceipts: {
    receiptNumber: 'Receipt Number',
    transactionDate: 'Transaction Date',
    remainingAmount: 'Remaining Amount',
    bank: 'Bank',
    currency: 'Currency',
    sourceBroker: 'Source Broker',
    brokerReference: 'Broker Reference',
    receiptAmount: 'Receipt Amount',
    receiptBalanceOutstanding: 'Receipt Balance Outstanding',
    selectSourceBrokers: 'Select Source Brokers',
    selectBanks: 'Select Banks',
    transactionDateRange: 'Transaction Date Range',
    selectCurrencies: 'Select Currencies',
    receipting: 'Receipting',
    updateReceipt: 'Update Receipt',
    receiptDetails: 'Receipt Details',
    paymentDate: 'Payment Date',
    receiptType: 'Receipt Type',
    bankDetails: 'Bank Details',
    selectBank: 'Select Bank',
    amount: 'Amount',
    bankFee: 'Bank Fee',
    bankAccount: 'Bank Account',
    brokerDetails: 'Broker Details',
    paymentReference: 'Payment Reference',
    sourceBrokerPayer: 'Source Broker / Payer',
    employeeNotes: 'Employee Notes',
    receipt: 'Receipt',
    attachments: 'Attachments',
    createReceipt: 'Create Receipt',
    contractAllocation: 'Contract Allocation',
  },
  contractAllocation: {
    documentNo: 'Document No',
    insured: 'Insured',
    reinsured: 'Reinsured',
    binder: 'Binder',
    originalCurrency: 'Original Currency',
    bookedExchangeRate: 'Booked Exchange Rate',
    originalNetAmountDueBroker: 'Net Amount Due from broker',
    settlementCurrency: 'Settlement Currency',
    settlementExchangeRate: 'Settlement Exchange Rate',
    paidAmount: 'Paid Amount',
    forexGainLoss: 'FOREX Gain or Loss',
    forexPercentage: 'FOREX %',
    adjustment: 'Adjustment',
    premiumBalance: 'Premium Balance',
    forexPercentageOutOfRange: 'FOREX percentage must be between -5% and 5%',
    premiumBalanceCannotBeNegative: 'Premium balance cannot be negative',
    netAmountFromBroker: `Net Amount rec'd From Broker`,
    contractsAvailableForAllocation: 'Contracts Available for Allocation',
    policiesAllocatedAgainstReceipt: 'Policies Allocated Against Receipt',
    unallocate: 'Unallocate',
    allocate: 'Allocate',
  },
  premiumProcessing: {
    originalPremiumSchedule: 'Original Premium Schedule',
    documentNo: 'Document No',
    description: 'Description',
    days: '{{days}} days',
    gstOnEre: 'GST on ERE',
    closingReference: 'Closing Reference',
    otherDeductions: 'Other Deductions',
    insured: 'Insured',
    ppwDueDate: 'PPW Due Date',
    premiumStatus: 'Premium Status',
    shareOfPremiumSigned: 'Share of Premium Signed',
    gstOnPremium: 'GST on Premium',
    cedingCommission: 'Ceding Commission',
    gstOnCedingCommission: 'GST on Ceding Commission',
    sourceBrokerage: 'Source Brokerage',
    gstOnSourceBrokerage: 'GST on Source Brokerage',
    ere: 'ERE',
    withholdingTax: 'Withholding Tax',
    netPremiumDueFromBroker: 'Net Premium Due from Broker',
    pinnacleCommission: 'Pinnacle Commission',
    ait: 'AIT',
    taxesAndFees: 'Taxes and Fees',
    binderCashRemittance: 'Binder Cash Remittance',
    noticePeriod: 'Notice of Cancellation T&C',
    financeComments: 'Finance Comments',
    addYourCommentsHere: 'Add your comments here...',
    recordUpdatedFailed: 'Failed to update record. Please try again.',
    recordUpdatedSuccessfully: 'Record updated successfully!',
    balance: 'Balance',
    premiumPaid: 'Premium Paid',
    updateNocStatusFail:
      'Failed to update Notice of Cancellation status. Please try again.',
  },
  contractAdjustment: {
    contractAdjustment: 'Contract Adjustment',
    effectiveDate: 'Effective Date',
    adjustmentType: 'Adjustment Type',
    documentNumber: 'Document Number',
    legacyPINReferenceNumber: 'Legacy PIN Ref No',
    transactionDetailsAndClassification:
      'Transaction Details and Classification',
    pinnacleReferenceNumber: 'Pinnacle Ref No',
    brokerReference: 'Broker Reference',
    insured: 'Insured',
    underwritingYear: 'Underwriting Year',
    inceptionDate: 'Inception Date',
    expiryDate: 'Expiry Date',
    premiumPaymentWarranty: 'Premium Payment Warranty',
    paymentWarrantyDate: 'Payment Warranty Date',
    underwritingComments: 'Underwriting Comments',
    addYourReasonHere: 'Add your reason here...',
    midTermAdjustments: 'Mid-Term Adjustments',
    totalInsurableValue: 'Total Insurable Value',
    layerPremiumAdjustmentAmountProrated:
      'Layer Premium Adjustment Amount (100%) Prorated',
    layerPremiumAdjustmentValue: 'Layer Premium Adjustment Amount',
    headers: {
      documentNo: 'Document No',
      adjustmentType: 'Adjustment Type',
      tiv: 'TIV',
      layerPremiumAdjustmentAmountProrated:
        'Layer Premium Adjustment Amount (100%) Prorated',
      layerPremium: 'Layer Premium (100%)',
      shareOfPremiumSigned: 'Share of Premium signed',
      expiryDate: 'Expiry Date',
      ppwDueDate: 'PPW Due Date',
      effectiveDate: 'Effective Date',
    },
    uploadFiles: 'Upload Files',
    recordCreatedSuccessfully:
      'Contract adjustment record created successfully!',
    recordCreatedFailed: 'Create contract adjustment failed. Please try again.',
    confirmSubmissionTitle: 'Confirm Adjustment Submission',
    confirmSubmissionContent:
      'Once the adjustment record has been saved, it cannot be modified. Please review all details carefully before proceeding.',
    validation: {
      noNegationAllowed:
        'Premium Adjustment cannot be negation of the contract amount',
      noOverRefundAllowed:
        'Premium Adjustment cannot be over the contract amount',
      effectiveDateWithinContractRange:
        'Effective Date must be within the contract inception and expiry date range',
      policyExtensionExpiryDateLimit:
        'For Policy Extension, expiry date cannot be more than 549 days from inception date',
    },
  },
  contract: {
    contracts: 'Contracts',
    underwriting: 'Underwriting',
    premiumProcessing: 'Premium Processing',
    claims: 'Claims',
    documents: 'Documents',
    endorsements: 'Endorsements',
    adjustmentHistory: 'Adjustment History',
    status: {
      cancelled: 'Cancelled Ab Initio',
    },
  },
  dashboard: {
    subtitle:
      'Evaluate risk and decide if financial transactions are acceptable.',
    masterClaimsSubtitle:
      'Manage claims with real-time updates on status and payments.',
    overview: 'Overview',
    reportAndAnalytics: 'Report & Analytics',
    underwriterDashboard: 'Underwriter Dashboard',
    financeDashboard: 'Finance Dashboard',
    claimDashboard: 'Claim Dashboard',
    claimsTabs: {
      allMaster: 'All Master Claims',
      allBinder: 'All Binder Claims',
    },
    premiumDueTabs: {
      paid: 'Paid',
      unpaid: 'Unpaid',
    },
  },
  premiumDue: {
    title: 'Premiums',
    current: 'Current',
    overdue30Days: 'Overdue 30 days',
    overdue60Days: 'Overdue 60 days',
    overdue90Days: 'Overdue 90 days',
    overdueMoreThan90Days: 'Overdue more than 90 days',
    paid: 'Paid',
    noticeOfCancellationIssued: 'Notice of Cancellation Issued',
    netPremiumDueFromBroker: 'Net Premium Due from Broker',
    balanceNetAmountDue: 'Balance (Net Amount Due from Broker)',
    updateClosingStatusFail:
      'Failed to update closing status. Please try again.',
    premiumStatus: 'Premium Status',
    ppwDueDate: 'PPW Due Date',
    description: 'Description',
    selectBrokers: 'Select Brokers',
    selectReinsured: 'Select Reinsured',
    selectInsured: 'Select Insured',
    selectPremiumStatus: 'Select Premium Status',
    ppwDateFrom: 'PPW Date From',
    ppwDateTo: 'PPW Date To',
    noticeOfCancellationStatus: 'Notice of Cancellation Status',
    closing: 'Closing',
    selectClosing: 'Select Closing',
    status: {
      within30Days: 'Within 30 Days',
      overdue7Days: 'Overdue 7 Days',
      overdueMoreThan30Days: 'Overdue More than 30 Days',
      noticeOfCancellation: 'Notice of Cancellation',
    },
  },
  finance: {
    financeDashboard: 'Finance Dashboard',
  },
  sidebar: {
    home: 'Home',
    dashboard: 'Dashboard',
    policyManagement: 'Policy Management',
    viewMasterContract: 'View Master Contract',
    viewBinderContract: 'View Binder Contract',
    opportunity: 'Opportunity',
    createNewOpportunity: 'Create New Opportunity',
    submissions: 'Submissions',
    createNewSubmission: 'Create New Submission',
    cloneSubmission: 'Clone Submission',
    renewals: 'Renewals',
    createRenewalSubmission: 'Create Renewal Submission',
    cloneRenewalSubmission: 'Clone Renewal Submission',
    premiumReceipting: 'Premium Receipting',
    receipts: 'Receipts',
    createNewReceipt: 'Create New Receipt',
    approveClaimsPayments: 'Approve Claims Payments',
    claims: 'Claims',
    registerNewMasterClaim: 'Register New Master Claim',
    updateMasterClaim: 'Update Master Claim',
    closeMasterClaim: 'Close Master Claim',
    updateBinderClaim: 'Update Binder Claim',
    closeBinderClaim: 'Close Binder Claim',
    bordereauxReports: 'Bordereaux Reports',
    newBordereaux: 'New',
    existingBordereaux: 'Existing',
    portfolioAnalysis: 'Portfolio Analysis',
    referenceData: 'Reference Data',
    insuredRecords: 'Insured Records',
    reinsuredRecords: 'Reinsured Records',
    brokerRecords: 'Broker Records',
    binderRecords: 'Binder Records',
    currency: 'Currency',
    pricingAssumptions: 'Pricing Assumptions',
    fireSeverityCurves: 'Fire Severity Curves',
    catZoneRates: 'Cat Zone Rates',
    fireRates: 'Fire Rates',
    adequacyAssumptions: 'Adequacy Assumptions',
    referenceDataPricing: 'Reference Data',
    toolsAndUtilities: 'Tools and Utilities',
    settings: 'Settings',
  },
  currency: {
    currency: 'Currency',
    searchCurrencyIfExists: 'Search Currency if exists',
    currencyCode: 'Currency Code',
    currencyName: 'Currency Name',
    rate: 'Rate',
    year: 'Year',
    effectiveDate: 'Effective Date',
    upToDate: 'Up To Date',
  },
  claim: {
    claim: 'Claim',
    setupMasterClaim: 'Setup Master Claim',
    updateMasterClaim: 'Update Master Claim',
    masterClaim: 'Master Claim',
    masterClaimId: 'Master Claim ID',
    masterClaimStatus: 'Master Claim Status',
    documents: 'Documents',
    assignedHandler: 'Assigned Handler',
    setupMasterClaimLowercase: 'setup master claim',
    transactionDetailsAndClassification:
      'Transaction Details and Classification',
    insured: 'Insured',
    selectInsured: 'Select Insured',
    status: 'Master Claims Status',
    selectMasterClaimsStatus: 'Select Master Claims Status',
    lineOfBusiness: 'Line of Business',
    selectLineOfBusiness: 'Select Line of Business',
    subClass: 'Sub-Class',
    selectSubClass: 'Select Sub-Class',
    setupDetails: 'Setup Details',
    claimsHandler: 'Claims Handler',
    dateReported: 'Reported Date',
    selectClaimsHandler: 'Select Claims Handler',
    selectDate: 'Select Date',
    dateOfLoss: 'Date of Loss',
    dateOfLossMustBeBeforeOrEqualReportedDate:
      'Date of Loss must be before or equal to Reported Date',
    dateOfLossMustBeWithinContractDates:
      'Date of Loss must be within the contract inception and expiry date range',
    reportedDateMustBeAfterDateOfLoss:
      'Reported Date must be after Date of Loss',
    selectCatCode: 'Select Cat Code',
    catCode: 'Cat Code',
    causeOfLoss: 'Cause of Loss',
    selectCauseOfLoss: 'Select Cause of Loss',
    currency: 'Contract Currency',
    selectContractCurrency: 'Select Contract Currency',
    lossLocation: 'Loss Location',
    enterLossLocation: 'Enter Loss Location',
    lossDescription: 'Loss Description',
    enterCommentHere: 'Enter comment here',
    createClaim: 'Create Claim',
    uploadFile: 'Upload File',
    validationCheck: 'Validation Check',
    ourSystemIsAutomaticallyVerifyingYourInformation:
      'Our system is automatically verifying your information.',
    duplicateCheck: 'Duplicate Check',
    continue: 'Continue',
    navigation: {
      claimRegistration: 'Claim Registration',
      masterReserves: 'Master Reserves',
      contractAllocation: 'Contract Allocation',
      binderClaimsSummary: 'Binder Claims Summary',
      binderClaimsActions: 'Binder Claims Actions',
      claimsHistory: 'Claims History',
    },
    registerIndividualBinderClaim: 'Register Individual Binder Claim',
    contractAllocationHeaders: {
      binder: 'Binder',
      broker: 'Broker',
      reinsured: 'Reinsured',
      basisOfCover: 'Basis of Cover',
      currency: 'Currency',
      limit100: 'Limit (100%)',
      excess100: 'Excess (100%)',
      binderShareSigned: 'Binder Share Signed (%)',
    },
    binderClaimsSummaryHeader: {
      claimNo: 'Claim No',
      legacyClaimNo: 'Legacy Claim Number',
      binder: 'Binder',
      reinsured: 'Reinsured',
      broker: 'Broker',
      currency: 'Currency',
      shareOfPremiumSigned: 'Share of Premium Signed (%)',
      incurred: 'Incurred (Our Share)',
      payments: 'Payments (Our Share)',
      outstanding: 'Outstanding (Our Share)',
      claimStatus: 'Claim Status',
    },
    contractAllocationRegistered:
      'Contract allocation registered successfully!',
    contractAllocationRegistrationFailed:
      'Contract allocation registration failed. Please try again.',
    recordUpdatedSuccessfully: 'Claim record updated successfully!',
    recordUpdatedFailed: 'Update claim record failed. Please try again.',
    binderClaimsActions: {
      lossDetails: {
        title: 'Loss Details',
        claimsNo: 'Claims No',
        claimsHandler: 'Claims Handler',
        claimsStatus: 'Claims Status',
        lineOfBusiness: 'Line of Business',
        subClass: 'Sub-Class',
        reinsured: 'Reinsured',
        broker: 'Broker',
        referenceNo: 'Reference No',
        reportedDate: 'Reported Date',
        dateOfLoss: 'Date of Loss',
        selectCatCode: 'Select Cat Code',
        causeOfLoss: 'Cause of Loss',
        catEvent: 'Cat Event',
        lossLocation: 'Loss Location',
        city: 'City',
        country: 'Country',
      },
      claimBinderDetails: {
        title: 'Claim Binder Details',
        fguMarketLossIndemnity: '100% FGU Market Loss Indemnity (exc. costs)',
        totalIncurredCosts: '100% Total Incurred Costs',
        fguNetIndemnityPayments: 'I00% FGU Net Indemnity Payments',
        fguNetCostPayments: '100% FGU Net Cost Payments',
        fguMarketLossOutstandingIndemnity:
          'I00% FGU Market Loss Outstanding Indemnity (exc. costs)',
        totalOutstandingCosts: '100% Total Outstanding Costs',
      },
      programRIConsiderations: {
        title: 'Program RI Considerations',
        programCessionDeclarationName: 'Program Cession (Declaration Name)',
        programCession: 'Program Cession %',
        captiveSelfInsuredRetention:
          'Captive Self Insured Retention/In the Aggregate',
        riSelfInsuredRetention: 'RI Self Insured Retention/In the Aggregate',
        riCession: 'RI Cession',
        riCosts: 'RI Costs',
      },
      binderClaimsFinancialSummary: {
        title: 'Binder Claims Financial Summary',
        lossType: 'Loss Type',
        previousIncurred100OurLayer: 'Previous Incurred (100% Our Layer)',
        previousIncurredOurShare: 'Previous Incurred (Our Share)',
        payments100OurLayer: 'Payments (100% Our Layer)',
        paymentsOurShare: 'Payments (Our Share)',
        outstanding100OurLayer: 'Outstanding (100% Our Layer)',
        outstandingOurShare: 'Outstanding (Our Share)',
        newIncurred100OurLayer: 'New Incurred (100% Our Layer)',
        newIncurredOurShare: 'New Incurred (Our Share)',
      },
      comments: {
        title: 'Comments',
        commentTo: 'Comment To',
      },
    },
  },
  binderContract: {
    allContract: 'All Contract',
    myContract: 'My Contract',
    currentYear: 'Current Year',
  },
};

export default translations;
export enum DashboardClaimsTab {
  AllMaster = 'allMaster',
  AllBinder = 'allBinder',
}
